import React from 'react'

const NotFound = ({ children }) => (
  <div className="base-not-found">{children || <div className="base-not-found__text">Page not Found</div>}</div>
)

NotFound.displayName = 'NotFound'

export default NotFound
